import { useState } from "react";
import { toast } from "react-toastify";
import { updateSettlemetNoteAndAmount } from "../actions"

export const useSettlementOrdersHook = ({
   sellerId,
   sellerOrders,
   updateSettlementAmount = () => { }
}) => {
   let actions = [];
   const limit = 10

   const [isLoading, setIsLoading] = useState(false);
   const [localization, setLocalization] = useState({});
   const [isEditPriceModalOpen, setIsEditPriceModalOpen] = useState(false);
   const [editPriceData, setEditPriceData] = useState({});
   const [isEditDataLoading, setIsEditDataLoading] = useState(false);

   const onSelect = (event, rowData) => {
      const ordersClone = [...sellerOrders]
      if (rowData.tableData && rowData.tableData.id > -1) {
         ordersClone[rowData.tableData.id] = {
            ...ordersClone[rowData.tableData.id],
            isSelected: event.target.checked
         }
      }
      countAndUpdateSettlementAmount([...ordersClone])
   }

   const countAndUpdateSettlementAmount = async (ordersClone = []) => {
      let totalSettlementAmount = 0
      let isAnyOrderSelected = false
      let isAllOrderSelected = true

      ordersClone.forEach((orderData) => {
         let amount = 0
         if (orderData.isSelected) {
            const settilementAmount = orderData.settlementAmount || orderData.settlementAmount === 0 || orderData.settlement_amount || orderData.settlement_amount === 0 ? orderData.settlementAmount : orderData.payable_amount
            amount = settilementAmount
         }

         totalSettlementAmount += amount

         if (!isAnyOrderSelected && orderData.isSelected) {
            isAnyOrderSelected = true
         }

         if (!orderData.isSelected && isAllOrderSelected) {
            isAllOrderSelected = false
         }
      })

      updateSettlementAmount({ totalSettlementAmount, isAnyOrderSelected, isAllOrderSelected, orders: [...ordersClone] })
   }

   const toggleEditPriceModal = (isOpen, selectedOrder = {}, isDescriptionEdit = false) => {
      setIsEditPriceModalOpen(isOpen)
      if (isDescriptionEdit) {
         setEditPriceData({
            ...selectedOrder,
            isDescriptionEdit,
            settlementDescription: selectedOrder.settlement_description || ""
         })
      } else {
         const settilementAmount = selectedOrder.settlementAmount || selectedOrder.settlementAmount === 0 || selectedOrder.settlement_amount || selectedOrder.settlement_amount === 0 ? selectedOrder.settlementAmount : selectedOrder.payable_amount
         setEditPriceData({
            ...selectedOrder,
            isDescriptionEdit,
            settlementDescription: selectedOrder.settlement_description || "",
            totalAmount: selectedOrder.payable_amount || selectedOrder.settlementAmount,
            newAmount: settilementAmount
         })
      }
   }

   const handleInputChange = (e) => {
      const { value: inputValue, name } = e.target;
      if (name === "newAmount") {
         const reg = /^-?\d*(\.\d*)?$/;
         if (reg.test(inputValue) || inputValue === '' || inputValue === '-') {
            onChange(inputValue);
         }
      } else {
         setEditPriceData({
            ...editPriceData,
            [name]: inputValue
         })
      }
   };

   // '.' at the end or only '-' in the input box.
   const handleInputBlur = () => {
      let valueTemp = editPriceData.newAmount;
      if (editPriceData.newAmount.charAt(editPriceData.newAmount.length - 1) === '.' || editPriceData.newAmount === '-') {
         valueTemp = editPriceData.newAmount.slice(0, -1);
      }
      onChange(valueTemp.replace(/0*(\d+)/, '$1'));
   };

   const onChange = (newValue) => {
      setEditPriceData({
         ...editPriceData,
         newAmount: newValue
      })
   }

   const handleEditAmount = async () => {
      const ordersClone = [...sellerOrders]
      const orderIndex = editPriceData && editPriceData.tableData && editPriceData.tableData.id
      const settlementDescription = editPriceData.settlementDescription || ordersClone[orderIndex].settlement_description || ""
      const settlementAmount = !editPriceData.isDescriptionEdit ? Number(editPriceData.newAmount) || 0 : ordersClone[orderIndex].settlementAmount

      try {
         if (settlementAmount > editPriceData.payable_amount) {
            toast.info("Settlement amount cant be more than Payable amount.")
            return
         }

         setIsEditDataLoading(true)

         const descriptionPayload = {
            seller_id: sellerId,
            order_id: editPriceData.order_id,
            settlement_amount: settlementAmount,
            settlement_note: settlementDescription
         }
         const descriptionData = await updateSettlemetNoteAndAmount(descriptionPayload)

         if (orderIndex > -1) {
            ordersClone[orderIndex] = {
               ...ordersClone[orderIndex],
               settlement_description: settlementDescription,
               settlementAmount: settlementAmount
            }
         }

         countAndUpdateSettlementAmount([...ordersClone])

         toggleEditPriceModal(false)
      } catch (error) {
         console.log(error);
         toast.error("Something went wrong. Please try again.")
      } finally {
         setIsEditDataLoading(false)
      }
   }

   const handleAllSelectToggle = (event = {}) => {
      let ordersClone = [...sellerOrders]
      ordersClone = ordersClone.map((order) => {
         return {
            ...order,
            isSelected: event.target.checked
         }
      })
      countAndUpdateSettlementAmount([...ordersClone])
   }

   return {
      isLoading,
      isEditDataLoading,
      localization,
      actions,
      limit,
      onSelect,
      isEditPriceModalOpen,
      editPriceData,
      toggleEditPriceModal,
      handleInputChange,
      handleInputBlur,
      handleEditAmount,
      handleAllSelectToggle
   }
}